import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { lazy } from '@loadable/component'
// styles
import useStyles from "./styles";

// components
import Suspense from "../Suspense/Suspense";
import Header from "../MovieHeader/Header";
import Footer from "../Footer";

// pages
const MovieHome = lazy(() => import("../../pages/MovieHome"));
const MovieDetail = lazy(() => import("../../pages/movieDetail"));
const VideoList = lazy(() => import("../../pages/videoList"));
const SearchNotFound = lazy(() => import("../../pages/searchNotFound"));
const Login = lazy(() => import("../../pages/login"));
const AboutUs = lazy(() => import("../../pages/about"));
const ContactUs = lazy(() => import("../../pages/contactUs"));
const Subscribe = lazy(() => import("../../pages/subscribe"));
const ConfirmPlan = lazy(() => import("../../pages/confirmPlan"));
const AgreeServicePrivacyPolicy = lazy(() =>
  import("../../pages/agreeServicePrivacyPolicy"),
);
const SignUp = lazy(() => import("../../components/SignUp"));
const ForgotPassword = lazy(() => import("../../pages/forgotPassword"));
const ResetPassword = lazy(() => import("../../pages/resetPassword"));
const Search = lazy(() => import("../../pages/search"));
const Error = lazy(() => import("../../pages/error"));

const routes = [
  {
    path: "/video/detail/trailer/:videoId",
    component: MovieDetail,
  },
  {
    path: "/video/detail/movie/:videoId",
    component: MovieDetail,
  },
  {
    path: "/video/list",
    component: VideoList,
  },
  {
    path: "/video/search_not_found",
    component: SearchNotFound,
  },
  {
    path: "/video/search",
    component: Search,
  },
  {
    path: "/video",
    exact: true,
    component: MovieHome,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/about-us",
    component: AboutUs,
  },
  {
    path: "/contact-us",
    component: ContactUs,
  },
  {
    path: "/subscribe",
    component: Subscribe,
  },
  {
    path: "/confirm-plan/:id",
    component: ConfirmPlan,
  },
  {
    path: "/agree-service-privacy-policy",
    component: AgreeServicePrivacyPolicy,
  },
  {
    path: "/signup",
    component: SignUp,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    path: "/reset-password",
    component: ResetPassword,
  },
  {
    path: "/error",
    component: Error,
  },
  {
    component: Error,
  },
];

function RouteWithSubRoutes (route) {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={props => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

function MovieLayout (props) {
  const classes = useStyles();

  // global
  // var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <Header
        color='transparent'
        history={props.history}
        changeStyleOnScroll={{
          height: 0,
        }}
      />
      <div className={classes.content}>
        <Suspense>
          <Switch>
            {routes.map((route, i) => (
              <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>
        </Suspense>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(MovieLayout);
